import {user} from '../../utils.js';
import {PointDeliveryBIModel} from '../models/PointDeliveryBIModel.js';
import {track} from '../../tracking/bi-track';
import {EVENT_POINT_DELIVERY} from '../../events/triggers/point-delivery.js';

export const pointDeliverySelectedBIEventListener = () => {
    document.addEventListener(EVENT_POINT_DELIVERY, (pointDeliveryEvent) => {
        const pointDeliveryBIModel = PointDeliveryBIModel.createFromDomainEvent(user.id, pointDeliveryEvent);
        track(pointDeliveryBIModel);
    });
};